/** Explicit same-retailer quote pair, in cents; never an aggregate historical column. */
export interface ListedOfferEvidence {
 priceCents?:number|null
 originalPriceCents?:number|null
 priceStale?:boolean
 isPriceUnknown?:boolean
 inStock?:boolean|null
 status?:string|null
}
const positive=(n:unknown):n is number=>typeof n==='number'&&Number.isSafeInteger(n)&&n>0
export function listedDiscountMeta(offer:ListedOfferEvidence|null|undefined,displayedPriceCents?:number|null):{savingsPercent:number;fromPriceCents:number}|null{
 if(!offer||offer.priceStale===true||offer.isPriceUnknown===true||offer.inStock===false||(offer.status!=null&&offer.status!=='active'))return null
 const current=offer.priceCents,reference=offer.originalPriceCents
 if(!positive(current)||!positive(reference)||reference<=current)return null
 if(positive(displayedPriceCents)&&displayedPriceCents!==current)return null
 return {fromPriceCents:reference,savingsPercent:Math.round(100*(reference-current)/reference)}
}

/** Named pairs encode cents. Generic price/originalPrice has no inferable unit. */
export function normalizeListedOffer(input:unknown):ListedOfferEvidence|null{
 if(!input||typeof input!=='object')return null
 const row=input as Record<string,unknown>
 const pairs=[['price_cents','original_price_cents'],['priceCents','originalPriceCents']] as const
 const complete=pairs.filter(([price,reference])=>typeof row[price]==='number'&&typeof row[reference]==='number')
 if(complete.length!==1)return null
 const [price,reference]=complete[0]
 return {priceCents:row[price] as number,originalPriceCents:row[reference] as number,priceStale:row.priceStale===true||row.isStale===true,isPriceUnknown:row.isPriceUnknown===true,inStock:(row.in_stock??row.inStock) as boolean|undefined,status:typeof row.status==='string'?row.status:undefined}
}
